<template>
  <div class="pda-menu">
    <div class="menu-item" v-for="(item, i) in menuData" :key="i" @click="go(item.href)">
      <img class="icon" :src="`${baseUrl}/static/images/pda/${item.icon}.png`" alt="png">
      <p>{{item.name}}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'PdaMenu',
  data() {
    return {
      menuData: [
        {
          name: '回收清点',
          href: '/decontamination/recycle/index'
        },
        {
          name: '清洗分类',
          href: '/decontamination/recycle_inventory/index'
        },
        {
          name: '清洗消毒',
          href: '/decontamination/cleaning_disinfection/index'
        },
        {
          name: '清洗质检',
          href: '/checkpacking/cleaning_qualityInspection/index'
        },
        {
          name: '包装及打印',
          href: '/checkpacking/package_printing/index'
        },
        {
          name: '上架及灭菌',
          href: '/checkpacking/shelf_sterilization/index'
        },
        {
          name: '灭菌质检',
          href: '/sterilestorage/sterilization_qualityInspection/index'
        },
        {
          name: '发放',
          href: '/sterilestorage/issue/index'
        },
        {
          name: '无菌物品库存',
          href: '/sterilestorage/sterile_inventory/index'
        },
        {
          name: '物品接收',
          href: '/departmentdocking/item_acceptance/index'
        },
        {
          name: '科室申领',
          href: ''
        },
        {
          name: '科室申领清单',
          href: ''
        },
        {
          name: '使用登记',
          href: '/departmentdocking/use_registration/index'
        },
        {
          name: '科室无菌库',
          href: '/departmentdocking/warehouse/index'
        },
        {
          name: '患者使用记录',
          href: '/departmentdocking/patient_userecords/index'
        }
      ],
      baseUrl: window.location.origin
    }
  },
  computed: {
    ...mapGetters(['menu'])
  },
  created() {
    this.getMenu()
  },
  methods: {
    go(path) {
      if (!path) {
        this.$message.warning('功能开发中，敬请期待')
      } else {
        if (`${path}` === this.$route.path) {
          window.location.reload()
          return
        }
        this.$router.push(path)
      }
    },
    getMenu() {
      if (this.menu && this.menu.length > 0) {
        this.menuData = this.extractPdaMenu(this.menu)
      } else {
        setTimeout(() => {
          this.getMenu()
        }, 200)
      }
    },
    extractPdaMenu(menu) {
      // 提取pda菜单
      const m = []
      menu.forEach(i => {
        i.children.forEach(c => {
          if (c.id && c.show_pda) {
            m.push(c)
          }
        })
      })

      return m
    }
  }
}
</script>

<style lang="scss" scoped>
  .pda-menu {
    .menu-item {
      width: 33.33%;
      height: 130px;
      display: inline-block;
      text-align: center;
      vertical-align: bottom;
      margin-bottom: 30px;
      .icon {
        width: 65px;
        height: 65px;
        border-radius: 50%;
        overflow: hidden;
        margin-bottom: 10px;
      }
    }

  }
</style>